module.exports = __webpack_public_path__ + "slide1-welcomeoctopus.4d4169438a00397b166ca9d85e60a9db.hashedasset.svg";